import { getCoreRowModel } from "@tanstack/react-table"
import React from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { ProductTestResult } from "@/graphql/codegen/graphql"
import { overrideResultsTableColumns } from "@/screens/Products/components/Product/Quality/TestResults/components/OverrideTestResultsDialog/overrideResultsTableColumns"

interface OverrideTestResultsTableProps {
  productTestResults: ProductTestResult | null
}

const OverrideTestResultsTable: React.FC<OverrideTestResultsTableProps> = ({ productTestResults }) => {
  return (
    <AerosBaseTable<ProductTestResult>
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data: [productTestResults as ProductTestResult],
          columns: overrideResultsTableColumns,
          getCoreRowModel: getCoreRowModel(),
        },
      }}
      slotProps={{
        headerCell: {
          className: "bg-blue-100",
        },
      }}
    />
  )
}

export default OverrideTestResultsTable
